import React, { useState } from 'react';
import { Card, Row, Col, Typography, Tag, Space, Button, theme } from 'antd';
import { DownOutlined, UpOutlined, BulbOutlined } from '@ant-design/icons';

const { Text, Paragraph } = Typography;

// Phase 1: Static content. In Phase 2, replace with fetch from
// GET https://api.attachmentmanager.com/news
// Expected schema: [{ id, type, title, summary, url, date, tag }]
const STATIC_NEWS = [
  {
    id: 1,
    type: 'article',
    title: 'Getting Started with Asana Integrations',
    summary: 'Learn how to connect Asana with your favourite tools to streamline workflows across your organisation.',
    url: 'https://www.bdq.cloud/blog',
    date: '2024-12-01',
    tag: 'Blog',
  },
  {
    id: 2,
    type: 'news',
    title: 'BDQ: Trusted Asana Solutions Partner',
    summary: 'BDQ provides Asana consultancy, integration and custom app development services across UK and US markets.',
    url: 'https://www.bdq.cloud/partners/asana-bdq',
    date: '2024-11-15',
    tag: 'News',
  },
  {
    id: 3,
    type: 'ad',
    title: 'Need help with Asana?',
    summary: 'Book a free consultation with our Asana experts. Integration, training, and ongoing support available.',
    url: 'https://www.bdq.cloud/contact',
    date: null,
    tag: 'Get Help',
  },
];

const tagColors = {
  Blog: 'blue',
  News: 'green',
  'Get Help': 'orange',
  Update: 'purple',
};

const NewsFeed = () => {
  const { token } = theme.useToken();
  const [newsItems] = useState(STATIC_NEWS);
  const [collapsed, setCollapsed] = useState(true);

  // Phase 2: Uncomment to fetch from API
  // useEffect(() => {
  //   const fetchNews = async () => {
  //     try {
  //       const response = await fetch('https://api.attachmentmanager.com/news');
  //       const data = await response.json();
  //       if (data && data.length > 0) setNewsItems(data);
  //     } catch (e) {
  //       // Fall back to static content
  //     }
  //   };
  //   fetchNews();
  // }, []);

  if (!newsItems || newsItems.length === 0) return null;

  const displayItems = collapsed ? newsItems.slice(0, 3) : newsItems;

  return (
    <Card
      size="small"
      style={{
        margin: '1px 0 0 0',
        borderRadius: 0,
        boxShadow: 'none',
        borderTop: `1px solid ${token.colorBorderSecondary}`,
      }}
      bordered={false}
    >
      <Row justify="center">
        <Col span={22}>
          <Space style={{ marginBottom: 12 }}>
            <BulbOutlined style={{ color: '#4573D2' }} />
            <Text strong style={{ fontSize: 13 }}>From BDQ</Text>
          </Space>
          <Row gutter={[16, 12]}>
            {displayItems.map((item) => (
              <Col xs={24} md={8} key={item.id}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none' }}
                >
                  <Card
                    size="small"
                    hoverable
                    style={{
                      height: '100%',
                      borderRadius: 8,
                      border: `1px solid ${token.colorBorderSecondary}`,
                    }}
                  >
                    <Tag color={tagColors[item.tag] || 'default'} style={{ marginBottom: 6 }}>
                      {item.tag}
                    </Tag>
                    <Paragraph
                      strong
                      style={{ marginBottom: 4, fontSize: 13 }}
                      ellipsis={{ rows: 2 }}
                    >
                      {item.title}
                    </Paragraph>
                    <Paragraph
                      type="secondary"
                      style={{ fontSize: 12, marginBottom: 0 }}
                      ellipsis={{ rows: 2 }}
                    >
                      {item.summary}
                    </Paragraph>
                  </Card>
                </a>
              </Col>
            ))}
          </Row>
          {newsItems.length > 3 && (
            <Button
              type="link"
              size="small"
              onClick={() => setCollapsed(!collapsed)}
              style={{ marginTop: 8, padding: 0 }}
            >
              {collapsed ? <>Show more <DownOutlined /></> : <>Show less <UpOutlined /></>}
            </Button>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default NewsFeed;
